import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface DevState {
    showModels: boolean
    showAudioBatch: boolean
    fixedBatchDurationSec: number | null
    enableLogging: boolean
}

export const useDevStore = create<DevState>()(
    persist(
        (): DevState => ({
            showModels: false,
            showAudioBatch: false,
            enableLogging: false,
            fixedBatchDurationSec: null,
        }),
        { name: 'dev-settings' }
    )
)
